export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-D-c6cc04639d845a0f64db91e89dca90b7.jpg";